import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  postWrapper: {
    borderRadius: 4,
    ...theme.mixins.appContainer,
    ...theme.mixins.appContainersSpacing,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  userSection: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    gap: theme.spacing(1),
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    width: '100%',
    maxWidth: 180,
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  content: {
    marginTop: theme.spacing(1.5),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75),
  },
  footer: {
    marginTop: theme.spacing(1.5),
    display: 'flex',
    gap: theme.spacing(1),
  },
}));
